export default {
    individualCardStyle: {
        height: "209px",
        width: "230px",
    },

    cardHeader: {
        marginTop: "44px"
    }
}